// SEARCH HEADERS
$(".icon-search").click(function() {
    $(".close-search").addClass("active");
    $(".modal_search").addClass("show_search");
    $("#form-search-icon").addClass("active");
})
$(".close-search").click(function() {
    $(".close-search").removeClass("active");
    $(".modal_search").removeClass("show_search");
    $("#form-search-icon").removeClass("active");
})
$(".modal_search").click(function() {
    $(".close-search").removeClass("active");
    $(".modal_search").removeClass("show_search");
    $("#form-search-icon").removeClass("active");
})

// // Animation Slide img 
// const banner = document.getElementsByClassName('background_animation')[0];
// const blocks = document.getElementsByClassName('blocks');

// for (var i = 1; i < 400; i++) {
//     banner.innerHTML += "<div class='blocks'></div>";
//     blocks[i].style.animationDelay = `${i * 0.05}s`;
// }